import React from 'react';
import { CART_URL } from '../utils/constants';
import { CreditCardIcon, LockIcon, ClockIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingSection() {
  return <>
      <section id="pricing-cta" className="py-8 md:py-16 px-4 bg-white border-y border-gray-100" data-id="element-185">
        <div className="max-w-3xl mx-auto" data-id="element-186">
          <div className="bg-brown-dark rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border-2 border-caramel" data-id="element-187">
            <div className="p-5 md:p-10 text-center" data-id="element-188">
              <p className="text-caramel font-bold md:text-base tracking-widest uppercase mb-1.5 text-[16px]" data-id="element-189">
                VALOR TOTAL:
              </p>

              <div className="flex items-center justify-center gap-2 md:gap-3 mb-0" data-id="element-190">
                <span className="md:text-4xl font-heading font-bold text-gray-400 line-through text-[24px]" data-id="element-191">
                  $171
                </span>
                <span className="text-white text-[10px] md:text-sm font-bold px-2.5 py-0.5 md:px-3 md:py-1 rounded-full uppercase tracking-wider bg-[#A03308]" data-id="element-192">
                  91% DTO
                </span>
              </div>

              <p className="md:text-9xl font-heading font-extrabold text-caramel mb-0 text-[90px] leading-none" style={{
              textShadow: '0 0 30px rgba(212,168,83,0.5), 0 0 60px rgba(212,168,83,0.25)'
            }} data-id="element-193">
                $17
              </p>

              <p className="text-cream/80 font-medium text-xs md:text-base mb-3 md:mb-5" data-id="element-194">
                Ahorras $154 — un 90% de descuento
              </p>

              <a href={CART_URL} onClick={e => {
              e.preventDefault();
              trackInitiateCheckout();
              try {
                window.top!.location.href = CART_URL;
              } catch {
                window.location.href = CART_URL;
              }
            }} className="block w-full bg-[#15803d] hover:bg-green-700 text-white font-heading font-bold md:text-3xl min-h-[64px] py-5 px-8 rounded-xl shadow-[0_6px_24px_rgba(0,100,0,0.4),0_0_40px_rgba(0,180,0,0.15)] transition-all transform hover:-translate-y-1.5 hover:scale-[1.03] animate-pulse-glow mb-2 border-2 border-green-400/30 text-[20px]" data-id="element-195">
                QUIERO EMPEZAR HOY
              </a>

              <p className="text-cream/70 font-medium text-xs md:text-sm" data-id="element-196">
                Pago único · Sin suscripciones · Sin cargos ocultos
              </p>
            </div>
          </div>

          <div className="mt-5 md:mt-8 bg-amber-50 border-2 border-amber-400 rounded-[10px] p-4 md:p-8 text-center" data-id="element-197">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-198">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5 text-amber-600" data-id="element-199" />
              <p className="font-heading font-bold text-base md:text-xl text-brown-dark" data-id="element-200">
                ¿POR QUÉ ACTUAR HOY?
              </p>
            </div>
            <p className="text-gray-700 font-medium text-sm md:text-lg leading-relaxed max-w-xl mx-auto" data-id="element-201">
              El Plan de Arranque en 7 Días lo estoy incluyendo gratis por este
              tiempo. Después lo vendo por separado a $13 adicionales.
            </p>
          </div>

          <div className="mt-4 md:mt-8 flex flex-col items-center" data-id="element-202">
            <div className="flex items-center gap-2 mb-2" data-id="element-203">
              <LockIcon className="w-4 h-4 text-success-green" data-id="element-204" />
              <p className="text-xs text-gray-400 font-bold uppercase" data-id="element-205">
                Pago 100% Seguro
              </p>
            </div>
            <div className="flex gap-2 md:gap-3 text-gray-400" data-id="element-206">
              <CreditCardIcon className="w-7 h-7 md:w-8 md:h-8" data-id="element-207" />
              <div className="w-10 h-7 md:w-12 md:h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-208">
                VISA
              </div>
              <div className="w-10 h-7 md:w-12 md:h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-209">
                MC
              </div>
              <div className="w-10 h-7 md:w-12 md:h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-210">
                AMEX
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 md:py-16 px-4 bg-[#FFF3CD] border-t-2 border-b-2 border-[#D4A853]" data-id="element-211">
        <div className="max-w-2xl mx-auto text-center" data-id="element-212">
          <h3 className="text-xl md:text-3xl font-heading font-bold text-brown-dark mb-4 md:mb-6" data-id="element-213">
            ¿Y si lo compro y no lo uso?
          </h3>

          <p className="text-base md:text-lg text-gray-700 font-medium mb-1.5" data-id="element-214">
            Mira, seamos honestas.
          </p>

          <p className="text-base md:text-lg text-gray-700 font-medium mb-4 md:mb-6" data-id="element-215">
            Lo que vas a invertir hoy es menos que:
          </p>

          <div className="grid grid-cols-3 gap-2 md:gap-4 mb-5 md:mb-8 max-w-lg mx-auto" data-id="element-216">
            <div className="bg-white rounded-[10px] p-3 md:p-4 text-center shadow-sm border border-[#D4A853]/30 flex flex-col items-center justify-center" data-id="element-217">
              <span className="text-2xl md:text-3xl block mb-1" data-id="element-218">☕</span>
              <p className="text-xs md:text-sm text-gray-800 font-medium leading-tight" data-id="element-219">
                Dos cafés con tostadas en cualquier bar
              </p>
            </div>
            <div className="bg-white rounded-[10px] p-3 md:p-4 text-center shadow-sm border border-[#D4A853]/30 flex flex-col items-center justify-center" data-id="element-220">
              <span className="text-2xl md:text-3xl block mb-1" data-id="element-221">🚗</span>
              <p className="text-xs md:text-sm text-gray-800 font-medium leading-tight" data-id="element-222">
                Un viaje en Uber de 15 minutos
              </p>
            </div>
            <div className="bg-white rounded-[10px] p-3 md:p-4 text-center shadow-sm border border-[#D4A853]/30 flex flex-col items-center justify-center" data-id="element-223">
              <span className="text-2xl md:text-3xl block mb-1" data-id="element-224">🍕</span>
              <p className="text-xs md:text-sm text-gray-800 font-medium leading-tight" data-id="element-225">
                Una pizza que te comes un viernes
              </p>
            </div>
          </div>

          <p className="md:text-lg text-gray-700 font-medium mb-3 text-[12px]" data-id="element-226">
            La diferencia es que esos gastos desaparecen en minutos.
          </p>

          <p className="md:text-2xl font-bold text-green-800 text-[16px]" data-id="element-227">
            Este <span className="line-through opacity-60" data-id="element-228">puede</span>{' '}
            <span className="text-shimmer font-extrabold text-[120%] uppercase tracking-wide" data-id="element-229">
              VA A
            </span>{' '}
            devolverte <strong className="text-[110%]" data-id="element-230">$400</strong> al mes.
          </p>
        </div>
      </section>
    </>;
}